import { render } from "./CardThirty.vue?vue&type=template&id=06e662f0"
import script from "./CardThirty.vue?vue&type=script&lang=js"
export * from "./CardThirty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__